<div *ngIf="!showFileDialog && customerlistmode" style="width:35px!important; height:35px!important;">
    <img [@inbgOutAnimation] *ngIf="loading" class="blur-img" width="35" height="35" (click)="changeLogo()" src="../../assets/images/org_blank.png" />
    <img [@inbgOutAnimation] *ngIf="!loading" width="35" height="35" (click)="changeLogo()" [ngSrc]="imgurl" (error)="imgurl='../../assets/images/org_blank.png';" />    
</div>
<img *ngIf="!showFileDialog && !customerlistmode && !updating" class="img-thumbnail-big" (click)="changeLogo()" [src]="imgurl" (error)="imgurl='../../assets/images/org_blank.png';"/>
<div *ngIf="showFileDialog" class="modal-content">
    <div class="loading_overlay rounded" *ngIf="showSpinner">
        <app-loader></app-loader>
    </div>
    <div class="modal-header">
        <h4 class="modal-title">{{ 'customerlogo.logo' | trans }}</h4>
    </div>
    <div class="modal-body">
        <div class="custom-file">
            <input type="file" (change)="fileChangeEvent($event)" class="custom-file-input" id="validatedCustomFile" required>
            <label class="custom-file-label" for="validatedCustomFile" >{{selectedFiles ? selectedFileName : 'customerlogo.logolabel' | trans }}</label>
        </div>
        <p *ngIf="cropperready" class="text-muted pb-0 mb-0 pt-2">{{ 'customerlogo.cropimagehelp' | trans }}</p>
        <image-cropper 
            [imageChangedEvent]="imageChangedEvent"
            [maintainAspectRatio]="true"
            [aspectRatio]="1/1"
            format="webp"
            [resizeToWidth]="100" 
            (imageCropped)="imageCropped($event)"
            (cropperReady)="cropperReady()"
            (loadImageFailed)="loadImageFailed()"
        ></image-cropper>
        <p *ngIf="cropperready" class="text-muted pb-0 mb-0 pt-2">{{ 'customerlogo.croppreviewhelp' | trans }}</p>
        <img *ngIf="cropperready" class="p-1 pt-2 w-100" [src]="croppedImage" />
    </div>
    <div class="modal-footer">
        <div class="col">
            <button  (click)="closefileUpload()" type="button" class="btn-close w-100"><h6 class="btn-save-text">{{ 'customerlogo.close' | trans }}</h6></button>
        </div>
        <div class="col">
            <button  (click)="onDocumentSubmit()" type="button" class="btn-save w-100"><h6 class="btn-save-text">{{ 'customerlogo.save' | trans }}</h6></button>
        </div>
    </div>
</div>


